// extracted by mini-css-extract-plugin
export default {"Label":"YuJaSwitch_Label__7Qayw","Switch":"YuJaSwitch_Switch__l69Sc","Thumb":"YuJaSwitch_Thumb__Pvd4a"};